import type { AnalyticsAccountScopeUserSettings } from "owa-analytics-types";
import type WebSessionType from "./contract/WebSessionType";

const userTypeCache = new Map<string, string>();

export default function getUserType(accountKey: string, accountSettings?: AnalyticsAccountScopeUserSettings, isEdu?: boolean | undefined, overrideCalculatedUserType?: boolean): string {
    if (!userTypeCache.has(accountKey) || overrideCalculatedUserType) {
        let resolvedType: string;
        if (accountSettings?.SessionSettings?.WebSessionType != undefined) {
            if (accountSettings.SessionSettings.WebSessionType.toString() !==
                0..toString()) {
                if (accountSettings.IsConsumerChild) {
                    resolvedType = "c_child";
                }
                else if (accountSettings.SessionSettings.IsPremiumConsumerMailbox) {
                    resolvedType = "c_premium";
                    /* eslint-disable-next-line no-restricted-properties  -- (https://aka.ms/OWALintWiki)
                     * Adding IsShadowMailbox to restricted properties/methods.
                     *	> 'IsShadowMailbox' is restricted from being used. IsCloudCache/IsShadowMailbox should be resolved in ECS as a filter in a feature flight if possible. */
                }
                else if (accountSettings.SessionSettings.IsShadowMailbox) {
                    resolvedType = "c_shadow";
                }
                else {
                    resolvedType = "c_standard";
                }
            }
            else {
                resolvedType = isEdu ? "b_edu" : "b_standard";
            }
        }
        else {
            resolvedType = "unknown";
        }
        userTypeCache.set(accountKey, resolvedType);
    }
    
    return userTypeCache.get(accountKey) ?? "unknown";
}

export function test_resetUserType(): void {
    userTypeCache.clear();
}
